"use client";

import Image from "next/image";
import type { paymentItemType, pictureType, Translationtype } from "utils";
import { useEffect } from "react";

interface IPaymentProps {
  activePayment: paymentItemType | null;
  paymentItems: paymentItemType[];
  setActivePayment: (val: paymentItemType) => void;
  className?: string;
  title?: string;
  t: Translationtype;
}

export function Payments({
  activePayment,
  paymentItems,
  setActivePayment,
  className,
  title,
  t,
}: IPaymentProps) {
  useEffect(() => {
    const filtered = paymentItems?.filter((item) => item.isVisible);
    if (filtered?.length === 1) {
      setActivePayment(filtered[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentItems]);

  return (
    <div className="mb-6">
      <p className="mb-4 text-lg font-semibold">
        {t(`Global.${title}` as any) || ""}:
      </p>

      <div>
        {paymentItems.map((paymentItem, index: number) => {
          return (
            <div
              style={{ display: !paymentItem.isVisible ? "none" : "block" }}
              className={` bg-purple-100/10 mb-4 rounded-xl border-2 transition ${
                activePayment?.value === paymentItem.value
                  ? "bg-purple-950/5 border-purple-950/50"
                  : ""
              } ${className || ""} `}
              key={index}
            >
              <label className="flex flex-col  md:flex-row items-start md:items-center py-3 px-4 cursor-pointer">
                <div>
                  <input
                    key={activePayment?.label}
                    type="radio"
                    name="payment"
                    defaultChecked={activePayment?.value === paymentItem.value}
                    onChange={() => setActivePayment(paymentItem)}
                  />
                  <span className="ml-1">
                    {t(`Global.${paymentItem.label}` as any)}
                  </span>
                </div>
                <div className="ml-auto py-2 bg-white rounded flex items-center">
                  {paymentItem.pictures.map(
                    (picture: pictureType, pictureIndex: number) => (
                      <Image
                        key={pictureIndex}
                        src={picture.src}
                        width={picture.width}
                        height={100}
                        alt="LOGO"
                        className="first:ml-0 mx-1 last:mr-0"
                      />
                    )
                  )}
                </div>
              </label>
            </div>
          );
        })}
      </div>
    </div>
  );
}
